import { h, Fragment } from "preact";
import "../style.css";
import ContentCard from "./ContentCard";
import InvalidCard from "./InvalidCard";
import { useState, useEffect } from "preact/hooks";
import Cookies from "js-cookie";
import { calculateForeground } from "../internal_utilities/utilities";

const Reward = props => {
  const [isVisible, setIsVisible] = useState(true);
  const [language, setLanguage] = useState("en");
  const [renderConfig, setRenderConfig] = useState(null);
  const [currentCampaign, setCurrentCampaign] = useState();
  const [currentRewardStage, setCurrentRewardStage] = useState();
  const [nextRewardStage, setNextRewardStage] = useState();
  const [currentRewardStageIndex, setCurrentRewardStageIndex] = useState();
  const urlParams = new URLSearchParams(window.location.search);
  const currentCampaignId = urlParams.get("id");
  const giftCode = urlParams.get("code");
  const amount = urlParams.get("amount");
  const type = urlParams.get("type");

  const getCurrentLangugeObject = selectedLanguage => {
    let langConfig = renderConfig.config.widgetConfig.langConfig.offerPage;
    let defaultLanguage =
      renderConfig.config.widgetConfig.langConfig.defaultLanguage;

    if (renderConfig && langConfig.hasOwnProperty(language))
      return langConfig[selectedLanguage];
    else return langConfig[defaultLanguage];
  };

  const titleWordMap = [
    {
      placeholder: "<reward_offer>",
      value: `${amount * -1}${
        type === "percentage" ? "%" : window.Shopify.currency.active
      }`
    }
  ];
  const nextRewardWordMap = [
    {
      placeholder: "<reward_requirement>",
      value: nextRewardStage && nextRewardStage.rewardTarget
    }
  ];

  const wordReplacer = (sourceText, dataMap) => {
    let text = sourceText;
    dataMap.map(item => {
      text = text.replace(item.placeholder, `${item.value}`);
    });
    return text;
  };
  const config = {
    featureFlag: renderConfig && renderConfig.config.referral.featureFlag,
    simpleReferrals:
      renderConfig && renderConfig.config.referral.simpleReferrals
        ? renderConfig.config.referral.simpleReferrals
        : [],
    viralReferrals:
      renderConfig && renderConfig.config.referral.viralReferrals
        ? renderConfig.config.referral.viralReferrals
        : [],
    themeColors: {
      bgEndColor:
        renderConfig &&
        renderConfig.config.widgetConfig.commonConfig.bgEndColor,
      bgStartColor:
        renderConfig &&
        renderConfig.config.widgetConfig.commonConfig.bgStartColor,
      fgColor:
        renderConfig &&
        calculateForeground(
          renderConfig.config.widgetConfig.commonConfig.bgEndColor
        )
    },
    currentLanguage: renderConfig && getCurrentLangugeObject(language)
  };
  const setCookies = () => {
    Cookies.set(`discount_code`, giftCode, {
      expires: 2,
      sameSite: "lax",
      secure: true
    });
  };

  useEffect(() => {
    if (currentCampaignId) {
      setRenderConfig(window.ofcoConfig);
      const campaign = window.ofcoConfig.config.referral.viralReferrals.find(
        item => item.campaignId === parseInt(currentCampaignId, 10)
      );
      setCurrentCampaign(campaign);
      setCookies();
      console.log(campaign);
      campaign.rewardStage.forEach((item, index) => {
        if (
          item.discountConfig.discountType === type &&
          item.discountConfig.discountValue === parseInt(amount, 10)
        ) {
          setCurrentRewardStage(item);
          setCurrentRewardStageIndex(index);
          if (index !== campaign.rewardStage.length - 1)
            setNextRewardStage(campaign.rewardStage[index + 1]);
        }
      });
      window.Shopify.locale && setLanguage(window.Shopify.locale);
    }
  }, []);

  const getThemeColor = campaignType => {
    if (
      campaignType === "SIMPLE_REFERRAL" &&
      currentCampaign.thankyouPageConfig.giftPageColor
    )
      return currentCampaign.thankyouPageConfig.giftPageColor;
    else if (campaignType === "VIRAL_REFERRAL" && currentCampaign.giftPageColor)
      return currentCampaign.giftPageColor;
    else return "rgb(18,109,255)";
  };

  if (
    currentCampaignId &&
    currentCampaign &&
    window.location.pathname !== "/a/offers/reward"
  ) {
    return (
      // removing clean slate for the time being if required paste it below
      <div className="corner-midas-gift-popup">
        <style>
          {currentCampaign.thankyouPageConfig.widgetCustomCss &&
            currentCampaign.thankyouPageConfig.widgetCustomCss}
        </style>
        {isVisible && (
          <div className="corner-modal-wrapper fixed inset-0 flex flex-col items-center justify-center bg-black/50 z-50">
            {giftCode && currentCampaign && currentRewardStage ? (
              <Fragment>
                <ContentCard
                  onClose={() => {
                    window.location = `/discount/${giftCode}`;
                    setIsVisible(false)
                  }}
                  color={getThemeColor(currentCampaign.type)}
                  title={
                    config.currentLanguage.reward_share_page_title
                      ? wordReplacer(
                          config.currentLanguage.reward_share_page_title,
                          titleWordMap
                        )
                      : "Congrats you've unlocked a discount coupon for referring people"
                  }
                  giftCode={giftCode}
                  // TODO : add this to i18n Config in falcon
                  ctaText={
                    config.currentLanguage.share_modal_cta_text
                      ? config.currentLanguage.share_modal_cta_text
                      : "Continue Shopping"
                  }
                  copyText={
                    config.currentLanguage.copy_text
                      ? config.currentLanguage.copy_text
                      : "Copy Code"
                  }
                  explainertext={
                    config.currentLanguage.reward_share_page_description
                      ? config.currentLanguage.reward_share_page_description
                      : "The reward is automatically applied to this session. So you can purchase anything right now and the coupon discount will be already added to your cart. But if you want to use this code later or on an another device, copy the code below"
                  }
                />
                {currentRewardStageIndex !==
                  currentCampaign.rewardStage.length - 1 && (
                  <div className="flex justify-center w-full mt-5">
                    <div className="rounded-lg border border-solid bg-white flex shadow">
                      <div className="bg-green-100 bg-opacity-50 flex items-center justify-center px-5 flex-grow-0 text-2xl font-bold">
                        {`${nextRewardStage.discountConfig.discountValue * -1}${
                          nextRewardStage.discountConfig.discountType ===
                          "percentage"
                            ? "%"
                            : window.Shopify.currency.active
                        }`}
                      </div>
                      <div className="flex-grow py-4 pl-1 pr-4">
                        <p className="font-bold mb-1">
                          {config.currentLanguage
                            .reward_share_page_next_reward_title
                            ? config.currentLanguage
                                .reward_share_page_next_reward_title
                            : "Next Reward Stage "}
                        </p>
                        <p className="text-gray-500 m-0">
                          {config.currentLanguage
                            .reward_share_page_next_reward_description
                            ? wordReplacer(
                                config.currentLanguage
                                  .reward_share_page_next_reward_description,
                                nextRewardWordMap
                              )
                            : "Will be unlocked as soon as more people buy with your code"}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </Fragment>
            ) : (
              <InvalidCard
                onClose={() => setIsVisible(false)}
                title={
                  config.currentLanguage.invalid_reward_modal_title
                    ? config.currentLanguage.invalid_share_modal_title
                    : "Invalid Gift URL"
                }
                explainertext={
                  config.currentLanguage.invalid_reward_modal_description
                    ? config.currentLanguage.invalid_reward_modal_description
                    : "The Gift coupon cannot be redeemed by the referrers for themselves"
                }
                color={getThemeColor(currentCampaign.type)}
                ctaText={
                  config.currentLanguage.invalid_modal_cta_text
                    ? config.currentLanguage.invalid_modal_cta_text
                    : "Close"
                }
              />
            )}
          </div>
        )}
      </div>
    );
  }
};

export default Reward;
